export const TEXT_ALIGN = {
	LEFT: {VALUE: 'left', ICON: 'fas fa-align-left'},
	CENTER: {VALUE: 'center', ICON: 'fas fa-align-center'},
	RIGHT: {VALUE: 'right', ICON: 'fas fa-align-right'},
	UNDER: {VALUE: 'under', ICON: 'fas fa-underline', disabled: true},
	STRIKE: {VALUE: 'strike', ICON: 'fas fa-strikethrough', disabled: true},
}
